import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { SemanticPathService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CheckoutFacade } from '../../../root';

@Injectable({
  providedIn: 'root',
})
export class OrderConfirmationGuard {
  constructor(
    private checkoutService: CheckoutFacade,
    private router: Router,
    private semanticPathService: SemanticPathService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.checkoutService.getOrderDetails().pipe(
      map((orderDetails) => {
        if (orderDetails && Object.keys(orderDetails).length !== 0) {
          return true;
        } else {
          return this.router.parseUrl(this.semanticPathService.get('orders') ?? '');
        }
      })
    );
  }
}
